import * as React from 'react';
import { ProductPromotions } from '@grandvisionhq/products';
import { isValidAlgoliaSearchConfig, QueryAlgoliaProducts } from '@grandvisionhq/search';
import { compose, withLazyLoading } from '@grandvisionhq/utils';
import { RuntimeContext } from '../../runtime-context.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withAnchor } from '../../hocs/with-anchor.js';
import { useBloomreachPageName } from '../../hooks/use-bloomreach-page-name.js';

const CmsPromotion = ({ content  })=>{
    const { products =[] , productItemCompoundAlgolia =[] , supertitle ='' , title ='' , queryString ,  } = content;
    const promotionProducts = productItemCompoundAlgolia.length ? productItemCompoundAlgolia : products;
    const { algolia  } = React.useContext(RuntimeContext);
    const pageName = useBloomreachPageName();
    // We have two promotion components: old one is using queryString, and filterQuery for Algolia promotion
    const query = productItemCompoundAlgolia.length ? productItemCompoundAlgolia[0].filterQuery : queryString;
    const skus = React.useMemo(()=>promotionProducts.map(({ sku  })=>sku
        ).filter((sku)=>!!sku
        )
    , [
        promotionProducts
    ]);
    const config = React.useMemo(()=>{
        return {
            apiKey: algolia === null || algolia === void 0 ? void 0 : algolia.apiKey,
            appId: algolia === null || algolia === void 0 ? void 0 : algolia.appId,
            indexName: algolia === null || algolia === void 0 ? void 0 : algolia.productIndex.name,
            facets: algolia === null || algolia === void 0 ? void 0 : algolia.productIndex.facets
        };
    }, [
        algolia
    ]);
    // Either sku's or a querystring needs to be specified if we want to search
    const canSearch = promotionProducts.length > 0 || !!query;
    if (!canSearch || !title && !supertitle || !isValidAlgoliaSearchConfig(config)) {
        console.error('Error rendering CMSPromotion, missing content or invalid search configuration');
        return null;
    }
    return /*#__PURE__*/ React.createElement(QueryAlgoliaProducts, {
        algoliaConfig: config,
        skus: skus,
        queryString: query
    }, (searchState)=>{
        return !searchState.hasError && /*#__PURE__*/ React.createElement(ProductPromotions, {
            products: searchState.result,
            supertitle: supertitle,
            title: title,
            isLoading: searchState.isLoading,
            renderLocation: pageName
        });
    });
};
var Promotion = compose(withLazyLoading, withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsPromotion);

export { CmsPromotion, Promotion as default };
//# sourceMappingURL=Promotion.js.map
